import { IParamConfig } from "@core/services/interfaces/geral/param/IParamService";

const paramConfig: IParamConfig = {
  // Endpoints
  getParameterValueEndpoint: "/api/Geral/Parametro/ValorDoParametro",
};

export default paramConfig;
